export const randomId = () => {
  return Math.random().toString();
};
